import { render, staticRenderFns } from "./gestao-sidebar.vue?vue&type=template&id=195511ca&scoped=true&"
import script from "./gestao-sidebar.vue?vue&type=script&lang=js&"
export * from "./gestao-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./gestao-sidebar.vue?vue&type=style&index=0&id=195511ca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195511ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('195511ca')) {
      api.createRecord('195511ca', component.options)
    } else {
      api.reload('195511ca', component.options)
    }
    module.hot.accept("./gestao-sidebar.vue?vue&type=template&id=195511ca&scoped=true&", function () {
      api.rerender('195511ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/navegacao-v2/components/gestao-sidebar.vue"
export default component.exports